
/* ------------------------------------------------------------------------ */
/*		File: HoItWorks.tsx                                                 */
/*		Description: HoItWorks page definition                              */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */


import React from "react";
import { statusType } from "../../components/GenericComponents/generic.d";
import Menu from "../../components/cmpMenu/cmpMenu";
import IntroComponent from "../../components/cmpIntro/cmpIntro";
import Step from "../../components/cmpStep/cmpStep";
import Skill from "../../components/cmpSkill/cmpSkill";
import Card_545 from "../../components/cmpCard_545/cmpCard_545";
import Faq from "../../components/cmpFAQ/cmpFAQ";
import { useTranslation, withTranslation } from "react-i18next";

import "../../scss/general.css"; 
import "./howitworks.css";
import Card_Breadcumb from "../../components/cmpBreadcumb/cmpBreadcumb";
import Card_545_video from "../../components/cmpCard_545/cmpCard_545_video";
import Meta from "../../components/GenericComponents/meta";


/* ------------------------------------------------------------------------ */

const HowItWorks: React.FC = () => {
    
    const { t } = useTranslation();

    const infoMenus:any = t("menu", { returnObjects: true }); 
    const infoHowItWorks:any = t("howItWorks", { returnObjects: true });
    const detailMenu = infoMenus.filter((x:any) => x.id === "howitworks")[0] || null;

    return (
        <div className="header-parent">
            <Meta page={"howItWorks"} />
            <div className="cssHowItWorks">
                <Menu 
                    label={detailMenu!.label}
                    options={detailMenu!.submenus}
                    buttons={detailMenu!.buttons}
                    quotation={detailMenu!.quotation}
                />
                <div className="cssCol">
                    <Card_Breadcumb label={infoHowItWorks.breadcumb} />

                    {/* Section: How It Works */}

                    <section id="howItWorks">
                        <IntroComponent
                            label={infoHowItWorks.label}
                            description={infoHowItWorks.description}
                        />
                    </section>

                    {/* Section: Learning Process */}

                    <section id="learningProcess" className="learningProcess-container">
                        <IntroComponent
                            label={infoHowItWorks.content[0].label}
                            description={infoHowItWorks.content[0].description}
                        />
                        <div className="cssRowCenter demo_container">
                            {infoHowItWorks.content[0].content.map((item:any, index:number) => (
                                <Step
                                    key={`learningOutcomes-${index}`}
                                    description={item.description}
                                    src={item.src}
                                />
                            ))}
                        </div>   
                    </section>
                    
                    {/* Section: Technical Requirements */}

                    <section id="technicalRequirements">
                        <IntroComponent
                            label={infoHowItWorks.content[1].label}
                            description={infoHowItWorks.content[1].description}
                        />   
                        <div className="cssRowCenter demo_container">
                            {infoHowItWorks.content[1].content.map((item:any, index:number) => (
                                <Skill
                                    key={`skill-${index}`}
                                    label={item.label}
                                    src={item.src}
                                    status={statusType[item.status.toString().toUpperCase()  as keyof typeof statusType]}
                                />
                            ))}
                        </div>    
                    </section>

                    {/* Section: Demo - PENDING */}

                    <section id="demo">
                        <IntroComponent
                            label={infoHowItWorks.content[2].label}
                            description={infoHowItWorks.content[2].description}
                        />      
                        <div className="cssRowBetween demo_container">
                            {infoHowItWorks.content[2].content.map((item:any, index:any) => (
                                <Card_545_video  
                                    key={`demo-${index}`}
                                    card={item} 
                                />      
                            ))}
                        </div> 
                    </section>

                    {/* Section: FAQ */}

                    <section id="faq">
                        <IntroComponent
                            label={infoHowItWorks.content[3].label}
                            description={infoHowItWorks.content[3].description}
                        />   
                        <Faq   
                            questions={infoHowItWorks.content[3].content}
                        />
                    </section>

                </div>
            </div>
        </div>
    );  
};
export default withTranslation('translation', { withRef: true }) (HowItWorks);